import * as InactiveFees from "../../../src/Containers/FeesTable/InactiveFees.scss";
import { defaultArg, bind, map } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { Fee$reflection, convertFeeToViewModel } from "./Model.js";
import { singleton as singleton_1, map as map_1, tryFind } from "../../fable_modules/fable-library.3.7.20/List.js";
import { DateOnlyExtensions_toDate, decimalToTwoDecimals, truncateWithEllipsis, Locale$reflection, parseInt$ } from "../../Utils.js";
import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { record_type, bool_type, lambda_type, unit_type, int32_type, list_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { FeeFormTemplate$reflection } from "../FeeModal/Model.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useSelector } from "../../Redux/Store.js";
import { getTranslationFrom } from "../../Global.js";
import * as react from "react";
import { renderModal } from "../../Components/Modals/Choice/Choice.js";
import { getExpandableAreaHtml, getAmountIncludingVat, getInactiveFeesTableHeaders } from "./View.js";
import { equals, int32ToString } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { PeriodModule_toTranslation } from "../../DomainTypes.js";
import { parse } from "../../fable_modules/fable-library.3.7.20/Int32.js";
import { PageinationProps$1, Pagination } from "../../Components/Pagination/Pagination.js";
import { renderDotMenuAreaTable } from "../../Components/Table/Table.js";
import { Helpers_equalsButFunctions } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Helpers.fs.js";


function getEditFeeRowViewModel(getTranslation, locale, feeNr, feeTemplates, fees) {
    return map((fee_1) => convertFeeToViewModel(getTranslation, locale, feeTemplates, fee_1), bind((feeNr_1) => tryFind((fee) => (fee.FeeNumber === feeNr_1), fees), bind(parseInt$, feeNr)));
}

export class InactiveFeesTableProps extends Record {
    constructor(Fees, FeeTemplates, Locale, ReactivateFeeFn, UsesUnitAndUnitPrice, ClientNr) {
        super();
        this.Fees = Fees;
        this.FeeTemplates = FeeTemplates;
        this.Locale = Locale;
        this.ReactivateFeeFn = ReactivateFeeFn;
        this.UsesUnitAndUnitPrice = UsesUnitAndUnitPrice;
        this.ClientNr = (ClientNr | 0);
    }
}

export function InactiveFeesTableProps$reflection() {
    return record_type("Containers.FeesTable.InactiveFees.InactiveFeesTableProps", [], InactiveFeesTableProps, () => [["Fees", list_type(Fee$reflection())], ["FeeTemplates", list_type(FeeFormTemplate$reflection())], ["Locale", Locale$reflection()], ["ReactivateFeeFn", lambda_type(int32_type, unit_type)], ["UsesUnitAndUnitPrice", bool_type], ["ClientNr", int32_type]]);
}

export const renderInactiveFeesTable = FunctionComponent_Of_Z5A158BBF((props) => {
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const expandAreaRowIdState = react.useState(void 0);
    const reactivateFeeModalIsOpenState = react.useState(void 0);
    const displayFeeOpt = getEditFeeRowViewModel(getTranslation, props.Locale, expandAreaRowIdState[0], props.FeeTemplates, props.Fees);
    let reactivateFeeModalHtml;
    const matchValue = reactivateFeeModalIsOpenState[0];
    if (matchValue != null) {
        const feeNr = matchValue | 0;
        let bodyHtml;
        const children_1 = [getTranslation("Containers.FeesTable.ReactivateQuestion")];
        bodyHtml = react.createElement("div", {
            className: "p-2",
        }, ...children_1);
        reactivateFeeModalHtml = renderModal(getTranslation("Containers.FeesTable.Reactivate"), bodyHtml, getTranslation("Common.Cancel"), getTranslation("Common.Yes"), (_arg) => {
            reactivateFeeModalIsOpenState[1](void 0);
        }, (_arg_1) => {
            props.ReactivateFeeFn(feeNr);
            reactivateFeeModalIsOpenState[1](void 0);
        });
    }
    else {
        reactivateFeeModalHtml = react.createElement(react.Fragment, {});
    }
    const headers = getInactiveFeesTableHeaders(getTranslation, props.UsesUnitAndUnitPrice);
    const rows = map_1((fee) => {
        const rowId = int32ToString(fee.FeeNumber);
        return [toList(delay(() => append(singleton(truncateWithEllipsis(40, fee.Description)), delay(() => append(props.UsesUnitAndUnitPrice ? singleton(int32ToString(fee.Units)) : ((empty())), delay(() => append(singleton(decimalToTwoDecimals(props.UsesUnitAndUnitPrice ? fee.UnitPrice : fee.AmountExclVat)), delay(() => append(singleton(getAmountIncludingVat(fee.VatRatePercent, fee.AmountExclVat)), delay(() => append(singleton(DateOnlyExtensions_toDate(props.Locale.ILocale, fee.StartDate)), delay(() => append(singleton(defaultArg(map((date_1) => DateOnlyExtensions_toDate(props.Locale.ILocale, date_1), fee.EndDate), "")), delay(() => append(singleton(int32ToString(fee.BoundMonths)), delay(() => append(singleton(PeriodModule_toTranslation(getTranslation, fee.Period)), delay(() => {
            let matchValue_1;
            return singleton((matchValue_1 = [fee.NoNextInvoice, fee.FinalInvoiceSent], matchValue_1[0] ? getTranslation("Containers.FeesTable.Terminated") : (matchValue_1[1] ? getTranslation("Containers.FeesTable.FinalInvoiced") : getTranslation("Containers.FeesTable.Unknown"))));
        })))))))))))))))))), rowId];
    }, props.Fees);
    const expandableArea = getExpandableAreaHtml(props.Fees, getTranslation, displayFeeOpt, props.Locale.ILocale, props.ClientNr);
    const dotMenu = singleton_1([getTranslation("Containers.FeesTable.Reactivate"), (arg_3) => {
        const arg_2 = parse(arg_3, 511, false, 32);
        reactivateFeeModalIsOpenState[1](arg_2);
    }]);
    const children_3 = [Pagination()(new PageinationProps$1((rows_1) => {
        let currentRowIdOpt;
        return renderDotMenuAreaTable(headers, rows_1, (_arg_3) => dotMenu, expandableArea, expandAreaRowIdState[0], (currentRowIdOpt = (expandAreaRowIdState[0]), (rowId_1) => {
            if (equals(currentRowIdOpt, rowId_1)) {
                expandAreaRowIdState[1](void 0);
            }
            else {
                expandAreaRowIdState[1](rowId_1);
            }
        }));
    }, rows, 10, 0)), reactivateFeeModalHtml];
    return react.createElement("div", {
        className: "inactive-fees",
    }, ...children_3);
}, "InactiveFeesTable", Helpers_equalsButFunctions, void 0, "renderInactiveFeesTable", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\FeesTable\\InactiveFees.fs", 134);

